<template>
  <div>
    <div class="row">
      <div class="col-md-12">

        <div class="form-group">
          <label for="ticket-description-code">Código</label>
          <input v-model="ticketDescription.code" class="form-control" id="ticket-description-code">
        </div>

        <div class="form-group">
          <label for="ticket-description-description">Descrição</label>
          <textarea v-model="ticketDescription.description" class="form-control" id="ticket-description-description"/>
        </div>

        <div class="form-group" v-if="servicesNames">
          <label for="ticket-description-scraper-name">Nome do serviço</label>
          <select v-model="ticketDescription.scraperName" class="form-control" id="ticket-description-scraper-name">
            <option :value="serviceName" v-for="serviceName in servicesNames" :key="serviceName">
              {{ serviceName }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-outline mr-2" @click="cancel">Cancelar</button>
        <button class="btn btn-primary" @click="save" :disabled="disabledSaveButton">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  created() {
    this.loadServiceNames()
  },
  computed: {
    disabledSaveButton() {
      return !this.ticketDescription.code ||
             !this.ticketDescription.description ||
             !this.ticketDescription.scraperName
    }
  },
  data: () => ({
    servicesNames: null
  }),
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    loadServiceNames() {
      const key = 'scrapingServiceToAdmin'
      const data = this.$ls.get(key)

      if (data)
        return this.servicesNames = data.map(s => s.name)

      const params = {
        meta: false,
        per_page: 10000,
        order: ['name', 'asc']
      }

      return this.axios.get('maestro/scraping_services', { params })
        .then(response => response.data)
        .then(services => {
          const serviceNames = services.map(s => s.name )

          this.$ls.set(key, services, { minutes: 5 })
          this.servicesNames = serviceNames
        })
        .catch(e => this.$notify.addError(e))
    },
    save() {
      this.$emit('saveEntity', this.ticketDescription)
    }
  },
  name: 'Form',
  props: {
    ticketDescription: { required: true, type: Object }
  }
}

</script>

<style scoped>

</style>